module.exports = __webpack_public_path__ + "img/wxkf.256e4777.png";